import { Container } from "react-grid-system";
import styled from "styled-components";

export const StyledDecision = styled(Container)`
	margin-top: 2.4rem;
`;
